/* STELBO — bara de actiuni de pe telefon (snippets/stelbo-dock.liquid).

   Singura treaba a scriptului: ascunde bara cat timp footerul e in ecran, ca
   acesta sa ramana complet vizibil. Celelalte stari (sertar deschis, camp de
   text focusat) sunt rezolvate doar din CSS, in assets/stelbo.css sect. 31.

   IntersectionObserver in loc de un listener de scroll: nu ruleaza nimic pe
   firul principal cat timp utilizatorul deruleaza, doar la intrarea si la
   iesirea footerului din ecran. */

if (!customElements.get('st-dock')) {
  customElements.define(
    'st-dock',
    class StDock extends HTMLElement {
      connectedCallback() {
        this.observe();

        // In theme editor, footerul se re-randeaza la fiecare modificare si
        // nodul observat ramane detasat — observatorul trebuie refacut.
        if (window.Shopify && Shopify.designMode) {
          this.onSectionLoad = () => this.observe();
          document.addEventListener('shopify:section:load', this.onSectionLoad);
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.onSectionLoad) document.removeEventListener('shopify:section:load', this.onSectionLoad);
      }

      observe() {
        this.observer?.disconnect();

        const footer = document.querySelector('.st-footer');
        if (!footer || !('IntersectionObserver' in window)) {
          this.classList.remove('is-hidden');
          this.ready();
          return;
        }

        this.observer = new IntersectionObserver((entries) => {
          this.classList.toggle('is-hidden', entries[entries.length - 1].isIntersecting);
          this.ready();
        });
        this.observer.observe(footer);
      }

      // Prima stare se aplica FARA animatie: pe o pagina scurta footerul e in
      // ecran de la incarcare, iar bara n-are de ce sa alunece sub ochii
      // vizitatorului. Dublu rAF: cadrul 1 calculeaza stilul cu is-hidden,
      // abia cadrul 2 porneste tranzitiile (un singur rAF le-ar prinde in
      // acelasi calcul de stil si bara ar aluneca oricum).
      ready() {
        if (this.isReady) return;
        this.isReady = true;
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-ready')));
      }
    }
  );
}
